import { useEffect, useRef } from 'react'
type Options = IntersectionObserverInit
export const useVideoInViewport = (options?: Options) => {
  const videoRef = useRef<HTMLVideoElement | null>(null)

  useEffect(() => {
    const video = videoRef.current
    if (!video) return

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          video.play().catch(() => {})
        } else {
          video.pause()
        }
      },
      {
        threshold: 0.8,
        ...options,
      }
    )
    observer.observe(video)

    return () => observer.disconnect()
  }, [options])

  return videoRef
}
